import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, { useState, useEffect } from 'react';
import styles from './vocabularycard.module.css';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import IconButton from '@mui/material/IconButton';

export default function VocabularyCard(props) {
    const field = props.field;
    const color = props.color;

    const [flipped, setFlipped] = useState(false);

    useEffect(() => {

    }, []);

    function flip() {
      setFlipped(!flipped);
    }
    
    return (
    <div onClick={flip} className={styles.cardcontainer + (flipped ? " " + styles.flipped : "")}>
        <Front field={field} color={color} />
        <Back field={field} color={color} />
    </div>

    )
}

function speak(field) {
  
}
  
  function Front(props) {
    const field = props.field;
    const color = props.color;

      return (
        <>
        {field &&
        <Box className={styles.front} sx={{
            height: 450,
            width: 500,
            borderRadius: 1,
            backgroundColor: color + '.dark',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
        <Stack sx={{ alignItems: 'center' }} spacing={6}>
        <img className={styles.wordimage} src={require('../assets/' + field.image + '.png')}>
                        </img>
                        <IconButton size="large" onClick={() => speak({ text: field.name })}>
        <PlayCircleIcon fontSize="inherit" />
        </IconButton>
            <h2>{field.name}</h2>
        </Stack>
        </Box>
        }
        </>
      )
  }
  
  function Back(props) {
    const field = props.field;
    const color = props.color;

      return (
        <>
        {field &&
        <Box className={styles.back} sx={{
            height: 450,
            width: 500,
            borderRadius: 1,
            backgroundColor: color + '.dark'
          }}>
            <h2>{field.translation}</h2>
        </Box>
                }
        </>
      )
  }
  

  